module services {
    export module logistics {
        export class LiveTrackingSettingService implements interfaces.logistics.ILiveTrackingSettingService {

            static $inject = ["$resource", "ENV","$http", "$timeout","generalService"];

            constructor(private $resource: ng.resource.IResourceService, private ENV: interfaces.applicationcore.serverConfig,private $http: ng.IHttpService,private $timeout: ng.ITimeoutService,public generalService: interfaces.applicationcore.IGeneralService) {
            }


            getList(): ng.resource.IResourceClass<interfaces.logistics.ILiveTrackingSettingDisplay> {
                return this.$resource<interfaces.logistics.ILiveTrackingSettingDisplay>(this.ENV.DSP_URL + "LiveTrackingSetting/GetList", {
                    connectSearch: '@connectSearch',
                    numberRecords: '@numberRecords',
                    pageNumber: '@pageNumber',
                }, {
                        query: {
                            method: 'GET',
                            isArray: true,
                            interceptor: { response: config.appResourceDateInterceptor.parseResponseDates },
                            params: {
                                numberRecords: 25,
                                pageNumber: 1,
                            }
                        }
                    });
            } 

            getLiveTrackingSettingExcel(params: any): ng.IPromise<void> {
                var pdfDownload = document.createElement("a");
                document.body.appendChild(pdfDownload);

                var url = this.ENV.DSP_URL + 'LiveTrackingSetting/GetLiveTrackingSettingExcel?';

                var searchObject: interfaces.applicationcore.ISearchObject = {
                    filters: [],
                    sorts: []
                }
                searchObject = params.connectSearch;

                url += 'connectSearch=' + btoa(JSON.stringify(searchObject));

                return this.$http({
                    method: 'GET',
                    responseType: 'arraybuffer',
                    url: url,
                }).then((response) => {
                    var filename = response.headers()['x-filename'] || 'supplierDownload.xlsx';
                    var fileBlob = new Blob([response.data as BlobPart], { type: 'application/octet-stream' });

                    if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for IE browser
                        window.navigator.msSaveBlob(fileBlob, filename);
                    } else { // for other browsers
                        var fileURL = window.URL.createObjectURL(fileBlob);
                        pdfDownload.href = fileURL;
                        pdfDownload.download = filename;
                        pdfDownload.click();
                        pdfDownload.remove();
                    }

                    this.$timeout(() => {
                        this.generalService.displayMessage("Your download has started.", Enum.EnumMessageType.Success);
                    });
                }).catch((errorResponse) => {
                    var fileBlob = new Blob([errorResponse.data], { type: 'application/json' });
                    var fileURL = window.URL.createObjectURL(fileBlob);
                    const reader = new FileReader();

                    // This fires after the blob has been read/loaded.
                    reader.addEventListener('loadend', (e: ProgressEvent) => {
                        const text = e.target['result'];

                        this.$timeout(() => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>JSON.parse(text));
                        });
                    });

                    // Start reading the blob as text.
                    reader.readAsText(fileBlob);
                });
            }    

            getLiveTrackingSetting(liveTrackingSettingId: number): ng.resource.IResourceClass<interfaces.logistics.ILiveTrackingSetting> {
                return this.$resource<interfaces.logistics.ILiveTrackingSetting>(this.ENV.DSP_URL + "LiveTrackingSetting/GetLiveTrackingSetting", {
                    liveTrackingSettingId: liveTrackingSettingId
                }, {
                        query: {
                            method: 'GET',
                            isArray: false,
                            interceptor: { response: config.appResourceDateInterceptor.parseResponseDates }
                        }
                    });
            }

            save(): ng.resource.IResourceClass<interfaces.applicationcore.IMessageHandler> {
                return this.$resource<interfaces.applicationcore.IMessageHandler>(this.ENV.DSP_URL + "LiveTrackingSetting/Save");
            }

            getTrackingProviders(): ng.resource.IResourceClass<interfaces.applicationcore.IDropdownModel> {
                return this.$resource<interfaces.applicationcore.IDropdownModel>(this.ENV.DSP_URL + "LiveTrackingSetting/GetTrackingProviders", {});
            } 

            getTrackingProviderAdditionalAttributes(trackingProvider:string): ng.IPromise<string | void> {

                var url = this.ENV.DSP_URL + 'LiveTrackingSetting/GetTrackingProviderAdditionalAttributes?trackingProvider='+trackingProvider;
               return   this.$http({
                    method: 'GET',
                    responseType: 'text',
                    url: url,
                }).then((response) => {
                       response;
                });                
            }      


        }
    }
    angular.module("app").service("LiveTrackingSettingService", services.logistics.LiveTrackingSettingService);
}